import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HomepageService {

  constructor() { }

  private memberPrice = new BehaviorSubject<number>(0);
  castMemberPrice = this.memberPrice.asObservable();

  private onOffStatus = new BehaviorSubject<number>(0);
  castonOffStatus = this.onOffStatus.asObservable();

  showMemberPrice(price) {
    this.memberPrice.next(price);
  }

  memberPriceOnOffStatus(status) {
    this.onOffStatus.next(status);
  }

}
